import { GetCompanyQuery, RepresentativeRole } from '@blockpulse3/graphql/hooks';
import { IUserContext } from '@blockpulse3/web-client/auth';

export function canUserUpdateCompany(
  user: IUserContext['user'],
  company: GetCompanyQuery | undefined,
): boolean {
  if (!user) {
    return false;
  }
  if (!company) {
    return false;
  }

  const { individualIdentity } = user;
  const { companyRepresentative } = company.company;

  return !!companyRepresentative.find(
    (rep) =>
      [
        RepresentativeRole.PRESIDENT,
        RepresentativeRole.COMPANY_MANAGER,
        RepresentativeRole.SIGNER,
        RepresentativeRole.CREATOR,
      ].includes(rep.role) &&
      rep.representativeIdentity.individualIdentity?.id === individualIdentity?.id,
  );
}
